/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { AppBar, Toolbar } from "@mui/material";
import { HeaderContent } from "layout/MainLayout/Header/HeaderContent";

const PrimaryHeader = () => {
    
    return (
        <>
            <AppBar
                position='relative'
                color='inherit'
                elevation={0}
                id='simplicity-header-bar'
                className='simplicity-header-bar no-print'
            >

                <Toolbar className='brand-toolbar'>

                    <HeaderContent/>

                </Toolbar>

            </AppBar>
        </>
    );
};

export { PrimaryHeader };
